module.exports = __webpack_public_path__ + "img/value_bg_img.a0c1854a.png";